import { render, staticRenderFns } from "./FAQsComponent.vue?vue&type=template&id=2f72bc46&"
import script from "./FAQsComponent.vue?vue&type=script&lang=js&"
export * from "./FAQsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports